import { useId } from "react";
import { Tooltip } from "react-tooltip";
import { AiFillInfoCircle } from "react-icons/ai";

const TooltipIcon = ({ text }) => {
  const id = useId();

  return (
    <>
      <sup>
        <AiFillInfoCircle className="tooltip-icon me-1" data-tooltip-id={id} />
      </sup>
      <Tooltip
        id={id}
        style={{
          zIndex: 1000,
          fontSize: "14px",
          maxWidth: "500px",
        }}
      >
        <p style={{ textAlign: "justify" }}>{text}</p>
      </Tooltip>
    </>
  );
};

export default TooltipIcon;
